import React from 'react';
import MultichoiceFilterGroup from '../components/MultichoiceFilterGroup';

import type { IFilter } from '../types';

const FilterTypePlacement = ({
  className = '',
  isMobile = false,
  ...props
}: IFilter): JSX.Element => (
  <MultichoiceFilterGroup
    className={className}
    isMobile={isMobile}
    {...props}
    Filter={FilterTypePlacement}
    expandLabel="Показать все типы размещения"
    visibleItems={5}
  />
);

export default Object.assign(FilterTypePlacement, {
  filterName: 'hotel_type',
  filterLabel: 'Тип размещения',
});
